<section class="middle-section">

  <div class="top-section">
    <h3>
      Pricing
    </h3>
  </div>
  <div class="info-planselection">
    <h3> Please select a plan.
      <!-- <br>First month is FREE and you can cancel at anytime. -->
    </h3>
  </div>
  <div class="middle-section">
    <div class="container">
      <div class="main-section">
        <form [formGroup]="planForm" (ngSubmit)="OnPlanSelection()">
          <div class="rate-request-form">
            <div class=" table-resposive">
              <div class="col-md-12 overflow-auto">
                <table class="table  table-plan table-bordered ">
                  <tr>
                    <th></th>
                    <th *ngFor="let plan of planData">
                      {{plan.planName}}
                    </th>
                  </tr>
                  <tr class="box">
                    <td><strong>Price Table</strong></td>
                    <td *ngFor="let plan of planData" [ngClass]="{
											'box-yellow':plan.planName === 'Basic',
											'box-blue':plan.planName === 'Advanced',
											'box-green':plan.planName === 'Pro',
											'box-voilate':plan.planName === 'Pro+',
											'box-pink':plan.planName === 'Elite'
										  }">
                      <span *ngIf="plan.planCost > 0">${{plan.planCost}}/Month</span>
                      <span *ngIf="plan.planCost == 0">Free</span>
                    </td>
                  </tr>
                  <tr *ngFor="let item of searchCategories">
                    <td>
                      {{item.name}}
                    </td>
                    <td *ngIf="basic == true">
                      <div *ngIf="item.isBsic == true">
                        <img src="/assets/images/tick.svg" alt="" srcset="" />
                      </div>
                      <div *ngIf="item.isBsic == false">
                        <img src="/assets/images/cancel.svg" alt="" srcset="" />
                      </div>
                    </td>
                    <td *ngIf="advanced == true">
                      <div *ngIf="item.isAdvanced == true">
                        <img src="/assets/images/tick.svg" alt="" srcset="" />
                      </div>
                      <div *ngIf="item.isAdvanced == false">
                        <img src="/assets/images/cancel.svg" alt="" srcset="" />
                      </div>
                    </td>
                    <td *ngIf="pro == true">
                      <div *ngIf="item.isPro == true">
                        <img src="/assets/images/tick.svg" alt="" srcset="" />
                      </div>
                      <div *ngIf="item.isPro == false">
                        <img src="/assets/images/cancel.svg" alt="" srcset="" />
                      </div>
                    </td>
                    <td *ngIf="proPlus == true">
                      <div *ngIf="item.isProPlus == true">
                        <img src="/assets/images/tick.svg" alt="" srcset="" />
                      </div>
                      <div *ngIf="item.isProPlus == false">
                        <img src="/assets/images/cancel.svg" alt="" srcset="" />
                      </div>
                    </td>
                    <td *ngIf="elite == true">
                      <div *ngIf="item.isElite == true">
                        <img src="/assets/images/tick.svg" alt="" srcset="" />
                      </div>
                      <div *ngIf="item.isElite == false">
                        <img src="/assets/images/cancel.svg" alt="" srcset="" />
                      </div>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td></td>
                    <td *ngFor="let plan of planData">
                      <p-radioButton name="group1"  [value]="plan.id" formControlName="selectedPlan" label="SELECT">
                      </p-radioButton>
                    </td>
                  </tr> -->
                  <tr>
                    <td></td>
                    <td *ngFor="let plan of planData">
                      <p-radioButton
                        name="selectedPlan"  
                        [value]="plan.id"
                        [formControl]="planForm.get('selectedPlan')"
                        label="SELECT">
                      </p-radioButton>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <button class="btn btn-signIn" type="submit">Next</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<div class="modal fade add-paymetpopup request-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true" style="overflow: auto !important;">
  <div class="modal-dialog modal-lg">
    <div class="modal-content text-left">
      <div class="modal-header">
        <h5 class="modal-title">Select Payment Method</h5>
        <!-- Bootstrap-5 uses data-bs-dismiss -->
        <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close" id="closepoup">
          <span class="pi pi-fw pi-times"></span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <h3 class="plan-cost">Plan cost : $ {{ plancost }}</h3>
        </div>
        <div id="paypal-button-container"></div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>


<!-- <div class="modal fade add-paymetpopup request-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true" style="overflow: auto !important;">
  <div class="modal-dialog modal-lg">
    <div class="modal-content text-left">
      <div class="modal-header">
        <h5 class="modal-title ">Select Payment Method</h5>
        <button type="button" data-dismiss="modal" id="closepoup" aria-label="Close" class="close-btn"
          #closeRateModalsub>
          <span class="pi pi-fw pi-times"></span>
        </button>
        <button id="openModalButton" [hidden]="true" data-toggle="modal" data-target=".add-paymetpopup">Open
          Modal</button>
      </div>
      <div class="modal-body">
        <div>
          <h3 class="plan-cost">
            Plan cost : $ {{ plancost }}
          </h3>
        </div>
        <div id="paypal-button-container"></div>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div> -->
<div class="container">
  <div class="main-section">
    <h5><strong> Choose the plan that fits your Ro-Ro operations </strong></h5>
    <h5 class="">Access PCTC and deep-sea Ro-Ro schedules, pricing insights, and rate requests from leading shipping lines — updated daily.</h5>
    <hr class="plan-divider">
    <!-- <h5><strong>Basic Plan</strong></h5>
    <h5>Select this plan to search the schedules for your transport needs and to get rate quotations from multiple
      providers.</h5>
    <h5><strong>Advanced Plan</strong></h5>
    <h5>This plan gives you the ability to sort the voyages by transit time and to view the voyage details</h5>
    <h5><strong>Pro Plan</strong></h5>
    <h5>This plan will give you access to the port calendar for over 400 ports. It is updated daily and includes the
      planned movements for 17 shipping lines.</h5>
    <h5><strong>Pro+ Plan</strong></h5>
    <h5>Get full overview of selected vessels voyage and arrival at destination. The system will analyse actual voyage
      performance and predict arrival at destination.
    </h5>
    <h5><strong>Elite</strong></h5>
    <h5>Get immediate notification when a user is submitting a freight rate request. You will also be able to quote for
      this freight rate request. The communication is encrypted and only visible between client & supplier.
      You will also get client contact details to quote outside ENL Solutions. <br>
    Get access to the Analytics section where ENL solutions analyse our vast amount of data to create insights into Ro/Ro - PCTC market.
    CUrrent Analytics
    <ul>
      <li>Schedule Reliability</li>
    </ul>
    </h5> -->
    <div class="mb-3" *ngFor="let plan of planData">
      <h5>
        <strong>{{ plan.planName }} Plan</strong>
      </h5>
      <div class="plan-description" [innerHTML]="plan.description"></div>
    </div>
</div>